// Extensible: add new layout modes here as they're built.
export enum CallLayoutMode {
  Grid = "grid",
  Spotlight = "spotlight",
}

export function getDefaultLayoutMode(
  visiblePeerCount: number,
  isScreensharing: boolean
): CallLayoutMode {
  return visiblePeerCount >= 2 && !isScreensharing
    ? CallLayoutMode.Grid
    : CallLayoutMode.Spotlight;
}
